import type { SQL } from "drizzle-orm";
import type { AnyPgColumn } from "drizzle-orm/pg-core";
import { sql } from "drizzle-orm";

import { sessionKeyToGucName } from "./rls-session.js";

/** @internal */
export function sessionSettingSqlForKey(sessionKey: string): SQL {
  const guc = sessionKeyToGucName(sessionKey);
  const escaped = guc.replace(/'/g, "''");
  return sql.raw(`current_setting('${escaped}', true)`);
}

/**
 * Policy-time SQL for one RLS context key → `current_setting('app.<snake(key)>', true)`.
 * Use in schema policies and {@link tableRls} helpers.
 */
export function rlsContextKey<K extends string>(key: K): SQL {
  return sessionSettingSqlForKey(key);
}

/**
 * Typed factory for context keys (autocomplete only; keys must match `mapSessionToContext`).
 */
export function rlsContextKeys<
  TRls extends { userId: string } & Record<string, string> = { userId: string },
>(): <K extends keyof TRls & string>(key: K) => SQL {
  return (key) => rlsContextKey(key);
}

/** `column =` session GUC for a context key. */
export function eqRlsContextColumn(column: AnyPgColumn | SQL, key: string): SQL {
  return sql`${column} = ${rlsContextKey(key)}`;
}
